import { viewTypes } from 'store/modules/search'

export default {
    methods: {
        goToSubjectArea (option) {
            if (option.customerSpecific) {
                this.$store.dispatch('Search/setViewType', viewTypes.learningPaths)
            }
            this.$store.dispatch('Search/setMainPackage', option.code)
            this.toggleSubjectAreasMenu()

            switch (this.viewType) {
            case 'all':
                this.$router.push({ name: 'all-content', params: { packageSlug: option.code } })
                break
            case 'collections':
                this.$router.push({ name: 'collection-list', params: { packageSlug: option.code } })
                break
            case 'courses':
                this.$router.push({ name: 'course-list', params: { packageSlug: option.code } })
                break
            case 'live':
                this.$router.push({ name: 'live-events', params: { packageSlug: option.code } })
                break
            case 'virtual_classrooms':
                this.$router.push({ name: 'virtual-classrooms', params: { packageSlug: option.code } })
                break
            case 'learning_paths':
                this.$router.push({ name: 'learning-paths', params: { packageSlug: option.code } })
                break
            }
            this.$store.dispatch('Search/setDefaultSortValue')
        },
        goToAllSubjectAreas () {
            this.$store.dispatch('Search/setMainPackage', null)
            this.$router.push({ 'name': 'all-packages-all-content' })
            this.toggleSubjectAreasMenu()
        }
    }
}
